import type { Screenshare as WherebyScreenshare } from '@whereby.com/browser-sdk/react'
import { type WherebyCallOwnershipStatus, WherebyFloatCardView } from '../../../../../../pure-js/enums/Whereby'
import { shouldAskBeforeConnectingWhereby } from '../../../../../../pure-js/libs/wherebyCallOwnership'
import { MediaPermissionState } from '../../../../../../pure-js/types/AppAssistant'

/** A shared screen whose picture has arrived. */
export type ScreenshareWithStream = WherebyScreenshare & { stream: MediaStream }

type CallMediaPermissions = { camera: MediaPermissionState; microphone: MediaPermissionState; isLoading: boolean }

export const hasScreenshareStream = (screenshare: WherebyScreenshare): screenshare is ScreenshareWithStream =>
  !!screenshare.stream

// A denied camera or microphone keeps the person out of the call, so nobody sits in it without sound or picture.
export const isCallMediaBlocked = ({ camera, microphone, isLoading }: CallMediaPermissions): boolean => {
  const isAnyDeviceDenied = camera === MediaPermissionState.DENIED || microphone === MediaPermissionState.DENIED
  return !isLoading && isAnyDeviceDenied
}

// Ask before taking the call from another tab, show the call once it can start, and prepare the room until then.
export const resolveCallView = (
  ownershipStatus: WherebyCallOwnershipStatus,
  isCallReady: boolean
): WherebyFloatCardView => {
  if (shouldAskBeforeConnectingWhereby(ownershipStatus)) return WherebyFloatCardView.ASK
  if (isCallReady) return WherebyFloatCardView.CALL

  return WherebyFloatCardView.PREPARING
}
